import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useAuthService from "../auth/AuthService";

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, login } = useAuthService();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      sessionStorage.setItem("redirectPath", location.pathname);
      login();
    }
  }, [isAuthenticated, isLoading, location.pathname, login]);

  if (isLoading || !isAuthenticated) {
    return null; // Prevent rendering anything while loading or redirecting
  }

  return children;
};

export default ProtectedRoute;
